import type { FaireProductEntity } from "../../entity_types/product";

export const p_6j59rud3pp: FaireProductEntity = {
  token: "p_6j59rud3pp",
  type: "product",
  name: "Thank You Hug Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/df8d67599831448385ecff91482a8adfb76e366b982767bd1f59326b4e68bbcb.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/395d6c61f5a07aa7acfa5b9000f91c9d8028f08460f239ca1b0be1acc11fbd77.png",
    "https://cdn.faire.com/fastly/74ab1cd9106044f417b52f0e044809290a67c60ba1caf2733f3d7dce8df65fb0.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:07.818Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
